export default {
    VIEW: 'ui-calendar.view',
    CREATE: 'ui-calendar.create',
    UPDATE: 'ui-calendar.update',
    DELETE: 'ui-calendar.delete',
};
